import type { SvgProps } from "@/utils/svg-wrapper";

import React from "react";

import { Svg } from "@/utils/svg-wrapper";

export const Convert3DCubeIcon: React.FC<SvgProps> = ({ className }) => (
  <Svg className={className} height="24" viewBox="0 0 24 24" width="24">
    <path
      d="M22.5 15C22.5 18.87 19.37 22 15.5 22L16.55 20.25"
      stroke="inherit"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M2.5 9C2.5 5.13 5.63 2 9.5 2L8.45 3.75"
      stroke="inherit"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M17.2396 2.21L14.8396 3.53996C14.2996 3.83996 13.8496 4.59995 13.8496 5.21995V7.75999C13.8496 8.37999 14.2896 9.13998 14.8396 9.43998L17.2396 10.77C17.7496 11.06 18.5896 11.06 19.1096 10.77L21.5096 9.43998C22.0496 9.13998 22.4996 8.37999 22.4996 7.75999V5.21995C22.4996 4.59995 22.0596 3.83996 21.5096 3.53996L19.1096 2.21C18.5996 1.93 17.7596 1.93 17.2396 2.21Z"
      fill="inherit"
      stroke="inherit"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M14.1992 4.4502L18.1792 6.75018L22.1192 4.46021"
      stroke="inherit"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M18.1797 10.8203V6.74023"
      stroke="inherit"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M5.89 13.21L3.49001 14.54C2.95001 14.84 2.5 15.5999 2.5 16.2199V18.76C2.5 19.38 2.94001 20.14 3.49001 20.44L5.89 21.77C6.4 22.06 7.23999 22.06 7.75999 21.77L10.16 20.44C10.7 20.14 11.15 19.38 11.15 18.76V16.2199C11.15 15.5999 10.71 14.84 10.16 14.54L7.75999 13.21C7.23999 12.93 6.4 12.93 5.89 13.21Z"
      fill="inherit"
      stroke="inherit"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M2.84961 15.4502L6.81961 17.7502L10.7696 15.4602"
      stroke="inherit"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M6.81934 21.8203V17.7402"
      stroke="inherit"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </Svg>
);
